import PadraoModel from 'src/core/model/PadraoModel.js'

export default class IcarrosCambioModel extends PadraoModel {
  recurso = 'icarros/cambios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Câmbios Icarros';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
